import type { AppNavGroup, AppNavItem, AppNavRootItem } from "./types";

export const isGroup = (
  item: AppNavGroup | AppNavItem | AppNavRootItem
): item is AppNavGroup => {
  return !!(item as any).items;
};
